module.exports = __webpack_public_path__ + "img/img4_1.4139fb7a.jpeg";